import PageTitle from 'components/PageTitle';
import { ContentLayout } from 'layouts/ContentLayout/ContentLayout';
import ActiveOrders from './ActiveOrders';
import Orders from './Orders';
import RecentUpdates from './RecentUpdates';
import CalendarEventList from './CalendarEventList';
import { useState } from 'react';
import MobilityOrderTrackingBanner from './MobilityOrderTrackingBanner';

const OrdersTracking = () => {
  const [graphStatus, setGraphStatus] = useState<string | null>(null);

  return (
    <ContentLayout className="min-h-[100vh] justify-start">
      <PageTitle className="mb-12 w-full" title="My orders" />
      <MobilityOrderTrackingBanner className="mb-6" />
      <div className="grid flex-1 grid-cols-2 gap-6 xl:grid-cols-3">
        <div className="col-span-full col-start-1 row-span-1 row-start-1 md:col-span-1">
          <ActiveOrders onStatusChange={(status) => setGraphStatus(status)} />
        </div>
        <div className="col-span-full col-start-1 row-span-1 row-start-2 md:col-span-1 xl:col-start-2 xl:row-start-1 ">
          <RecentUpdates />
        </div>
        <div className="col-span-full col-start-1 row-start-3 md:col-span-1 md:col-start-2 md:row-span-2 md:row-start-1 xl:col-start-3">
          <CalendarEventList />
        </div>
        <div className="col-span-2 ">
          <Orders graphStatus={graphStatus} setGraphStatus={setGraphStatus} />
        </div>
      </div>
    </ContentLayout>
  );
};

export default OrdersTracking;
